export const PROFESSIONAL_STATUS_PRE = 1;
/** コンサルタント種別: 通常コンサルタント */
export const PROFESSIONAL_TYPE_NORMAL = 1;
/** コンサルタント種別: フリーコンサルタント */
export const PROFESSIONAL_TYPE_FREE = 5;
